import Vue from 'vue'
const vm = new Vue()

const api = {}
/**
 * 查询授权人信息
 *
 */
api.getManagerByEnterpriseId = function(id) {
  let url = `/kj-kyc/enterprise/getManagerByEnterpriseId?enterpriseId=${id}`
  return vm.$http.get(url)
}
/**
 * 上传文件
 *
 */
api.uploadFile = function(mediaId, catgId, queObj) {
  let url = `/kj-media/media/opera/do/uploadMediaFile?modelCode=MKJ02CONTACT&catgId=${catgId}&busiKey=${mediaId}&sysCode=KJ_SYSTEM`
  return vm.$http.post(url, queObj)
}
/**
 * 校验授权人是否和当前登录用户一致
 *
 */
api.validateUserAssociation = function(queObj) {
  let url = `kj-sys/user/validateUserAssociation`
  return vm.$http.post(url, queObj)
}
/**
 * 更新授权人信息
 *
 */
api.updateExportManager = function(queObj) {
  let url = `/kj-kyc/eKyc/updateExportManager`
  return vm.$http.post(url, queObj)
}
/**
 * 更新登录信息
 *
 */
api.editManageUser = function(queObj) {
  let url = `kj-sys/user/editManageUser`
  return vm.$http.post(url, queObj)
}
export default api
